/* eslint-disable camelcase */
import { put, call, fork, takeLeading } from 'redux-saga/effects';
import { GET_WALLET_SUMMARY, GET_WALLET_TRANSACTIONS } from '../actionTypes';
import {
  WALLET_SUMMARY_API,
  WALLET_TRANSACTIONS_API
} from '../../constants/api-constants';

import * as API from '../../utils/ajax';
import * as Actions from './actions';

function* getWalletSummaryAsync(action) {
  try {
    const response = yield call(
      API.get,
      `${WALLET_SUMMARY_API}?${action?.value}`
    );
    yield put(Actions.getWalletSummarySuccess(response, action));
  } catch (error) {
    yield put(Actions.getWalletSummaryFailure(error, action));
  }
}

function* getWalletTransactionsAsync(action) {
  try {
    const response = yield call(
      API.get,
      `${WALLET_TRANSACTIONS_API}?${action?.value}`
    );

    yield put(Actions.getWalletTransactionsSuccess(response, action));
  } catch (error) {
    yield put(Actions.getWalletTransactionsFailure(error, action));
  }
}

export function* watchWalletSaga() {
  yield takeLeading(GET_WALLET_SUMMARY, getWalletSummaryAsync);
  yield takeLeading(GET_WALLET_TRANSACTIONS, getWalletTransactionsAsync);
}
const walletSaga = [fork(watchWalletSaga)];
export default walletSaga;
